import React from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmPurgeModal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  loading = false
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  const confirmLabel = confirmText ?? t('common.confirm');
  const cancelLabel = cancelText ?? t('common.cancel');

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onCancel} 
              aria-label={t('common.close')}
            ></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onCancel} 
              disabled={loading}
            >
              {cancelLabel}
            </button>
            <button 
              type="button" 
              className="btn btn-danger" 
              onClick={onConfirm} 
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="loading-dots me-2" role="status" aria-hidden="true"></span>
                  {confirmLabel}
                </>
              ) : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPurgeModal; 